import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdatePharmacy,
    deleteReminder,
    getAppointmentList,
    getListCalendarItems,
    getRecipientsOptions,
    updateCalendarItemStatus,
} from '../ReminderEndpoint'

export const useListReminders = (
    requestorId,
    timezoneId,
    filterRequest = {},
) => {
    const {reminderKeys} = QueryKeyManager(QueryKeyTypes.reminder, requestorId)
    return useQuery({
        queryKey: reminderKeys.list({timezoneId, filterRequest}),
        queryFn: () => getListCalendarItems(requestorId, filterRequest),
        enabled: !!requestorId,
    })
}

export const useRecipientsOptions = (requestorId, userId, isUse = false) => {
    const {reminderKeys} = QueryKeyManager(QueryKeyTypes.reminder, requestorId)
    return useQuery({
        queryKey: reminderKeys.recipientsOptions({userId}),
        queryFn: () => getRecipientsOptions(userId),
        enabled: !!requestorId && !!userId && !!isUse,
    })
}

// This only use for Appointment List at App Top Bar
export const useAppointmentListTopBar = (requestorId, hospitalId, type) => {
    const {reminderKeys} = QueryKeyManager(QueryKeyTypes.reminder, requestorId)
    return useQuery({
        queryKey: reminderKeys.listManagement({
            requestorId,
            hospitalId,
            type,
        }),
        queryFn: () => getAppointmentList(requestorId, hospitalId, type),
        enabled: !!requestorId && !!type,
    })
}

export const useReminderUpdateStatus = requestorId => {
    const {reminderKeys} = QueryKeyManager(QueryKeyTypes.reminder, requestorId)

    return useMutation({
        mutationFn: data => updateCalendarItemStatus(data, requestorId),
        onSuccess: (data, variables) => {
            if (data?.id) {
                showNotification(severityNotification.success, 'OK!!')
            }
        },
    })
}

export const useReminderCRUD = (type, requestorId) => {
    const {reminderKeys} = QueryKeyManager(QueryKeyTypes.reminder, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdatePharmacy(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteReminder(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data && data?.length > 0) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Reminder Update Successfully !!',
                    )
                }
            } else if (type === QueryCRUDTypes.delete) {
                showNotification(
                    severityNotification.success,
                    'Deletion performed successfully!!',
                )
            }
        },
    })
}
